<script setup lang="ts">
// PROPS
interface Props {
    slug: string;
    vin: string;
    brand: string;
    model: string;
    coverImage: string | null;
    price: number | null;
    routeName: string;
    highlightClass?: string;
}

const { highlightClass = '' } = defineProps<Props>();

defineEmits<{ click: [] }>();

const { tn, tt } = useTypedI18n();
</script>

<template>
    <NuxtLinkLocale
        :to="{ name: routeName, params: { slug } }"
        class="flex items-center gap-3 rounded px-2 py-2 hover:bg-neutral-100"
        :class="highlightClass"
        @click="$emit('click')"
    >
        <NuxtImg
            v-if="coverImage"
            :src="coverImage"
            class="size-14 shrink-0 rounded object-cover"
            sizes="56px"
            densities="x1"
            loading="lazy"
            alt=""
        />
        <div v-else class="size-14 shrink-0 rounded bg-neutral-100" />
        <div class="min-w-0 flex-1">
            <div class="truncate font-medium">{{ brand }} {{ model }}</div>
            <div class="flex items-baseline justify-between gap-2">
                <div class="truncate text-xs text-neutral-500">{{ tt('search.result.vin', { vin }) }}</div>
                <div v-if="typeof price === 'number'" class="shrink-0 text-sm font-semibold">{{ tn(price, 'currency') }}</div>
            </div>
        </div>
    </NuxtLinkLocale>
</template>
